export const removeMessage = (messageId: string) => (currentMessageIds: string[]) =>
	currentMessageIds.filter((id) => id !== messageId);
